import { Task1120TrackerFilterType } from "../Task1120TrackerFilter";
import { ColumnHeaderDateFilter } from "../../ReusableHeaderFilter/ColumnHeaderDateFilter";

const PickupDateColumnHeader = ({
  values,
  updateFilter,
}: Omit<Task1120TrackerFilterType, "updateFilter"> & {
  updateFilter: (name: string, value: string) => void;
}) => {
  const isActive = Boolean(
    values.START_DATE || values.END_DATE || values.SELECT_PERIOD
  );

  const handleClearFilter = () => {
    updateFilter("START_DATE", "");
    updateFilter("END_DATE", "");
    updateFilter("SELECT_PERIOD", "");
  };

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>PICKUP DATE</div>
      <ColumnHeaderDateFilter
        isActive={isActive}
        values={values}
        updateFilter={updateFilter}
        handleClearFilter={handleClearFilter}
      />
    </div>
  );
};

export default PickupDateColumnHeader;
